<template>
  <div class="gameplan">
    <div class="normal_box">
      <div class="item_detail select-item-box select_item_red">
        <div>场勘 <i :class="themeDetail.needVerify?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>搭建 <i :class="themeDetail.needConstruct?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>临促 <i :class="themeDetail.needSpr?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
        <div>转场 <i :class="themeDetail.needTransitions?['el-icon-success','color-green']:['el-icon-error','color-red']"></i></div>
      </div>
      <div class="item_detail" ><span class="item_title">装饰点位  </span><span>{{getThemeDecorates((themeDetail&&themeDetail.themeDecorates)||(themeConfig&&themeConfig.themeDecorates)||(submitInfo&&submitInfo.themeDecorates))}}</span></div>
      <div class="infoBox_cross_line_box"><div class="infoBox_cross_line"></div></div>
      <el-row v-if="themeDetail.needSpr">
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">临促人员人数限制  </span><span v-if="themeDetail.pgQtyLimit||themeDetail.pgQtyLimit===0">{{themeDetail.pgQtyLimit |toThousandslsFilter()}}</span></div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail"><span class="item_title">打卡/执行信息上传方式  </span>{{themeDetail.needPerformance==null?'':(themeDetail.needPerformance===1?'督导统一上传':'临促人员自行上传')}}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">单场投入预算  </span>{{themeDetail.investUnit |toThousandslsFilter()}}</div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail" v-if="themeDetail.needTransitions==0"><span class="item_title">每{{ getUnits('活动') }}执行活动天数 </span><span>{{themeDetail.perExecDays |toThousandslsFilter()}} 天</span></div>
          <div class="item_detail" v-else><span class="item_title">道具数量设置 </span><span  v-if="themeDetail.itemQuantity||themeDetail.itemQuantity===0">{{themeDetail.itemQuantity |toThousandslsFilter()}}</span></div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="item_detail"><span class="item_title">提报售点要求  </span>{{ pocRelateTypeDesc }}</div>
        </el-col>
        <el-col  :span="12">
          <div class="item_detail" v-if="themeDetail.pocRelateType=='2'"><span class="item_title">最少关联售点数  </span><span>{{themeDetail.pocCountMin |toThousandslsFilter()}}</span></div>
        </el-col>
      </el-row>
      <div class="item_detail">
        <span class="item_title">
          <div>额度分配信息</div>
        </span>
        <!-- <div class="edit-btn" v-if="(isBU&&subAssignList.length>0)||(isHQ&&themeDetail.isShow)" @click="showEditDialog()">编辑</div> -->
        <!-- <div class="assign-all" v-if="isOwner" >
          <div v-for="(item,i) of subAssignList" :key="i">
            {{ getName(item.buName) || getName(item.orgName) }} : {{ item.totalCountQty|| item.assignQty || 0 }}场 (已通过：{{ item.passedCountQty  || 0 }}场 / 审核中：{{ item.approvalCountQty || 0 }}场 / 未提报：{{ item.notReportCountQty  ||0 }}场)
          </div>
        </div>

        <div class="assign-all" v-else-if="curAssignInfo&&curAssignInfo.length>0">
          {{ (isBU&&getName(curAssignInfo[0].buName))||isRegion&&getName(getName(curAssignInfo[0].regionName)) }}  : {{ curAssignInfo[0].totalCountQty|| 0 }}场 (已通过：{{ curAssignInfo[0].passedCountQty  || 0 }}场 / 审核中：{{ curAssignInfo[0].approvalCountQty || 0 }}场 / 未提报：{{ curAssignInfo[0].notReportCountQty  ||0 }}场)
        </div>

        <div class="assign-all" v-else-if="subAssignList&&subAssignList.length>0">
          {{ (isBU&&getName(curAssignInfo[0].buName))||isRegion&&getName(getName(curAssignInfo[0].regionName)) }}  : {{ curAssignInfo[0].totalCountQty|| 0 }}场 (已通过：{{ curAssignInfo[0].passedCountQty  || 0 }}场 / 审核中：{{ curAssignInfo[0].approvalCountQty || 0 }}场 / 未提报：{{ curAssignInfo[0].notReportCountQty  ||0 }}场)
        </div> -->
      </div>

    <div>
      <div style="margin-top:-47px;" >
        <div class="table-box" v-for="bu of assignDetailList" :key="isRegion?bu.regionCode:bu.buCode">
          <div style="display:flex;width:100%">
            <div v-if="isRegion" class="title-box">{{ getName(bu.regionName) || getName(bu.orgName)}}</div>
            <div :span="5" v-else class="title-box">
            <div class="font-red">
              {{ getName(bu.buName) || getName(bu.orgName)}}
            </div>
            <div style="margin-top:5px;font-size:12px;">
              执行人：{{getExecutorName(bu)}}
            </div>
            </div>
            <div :span="8" v-if="isRegion" class="base-info-box base-info-box-region">
              <div>
                <div class="base-info-num">{{ bu.assignQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已分配</div>
              </div>
              <div class="separate-line"></div>
              <div>
                <div class="base-info-num link-style" @click="gotoSubmitPage('bu','submit',bu)">{{ bu.submitCountQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已提报</div>
              </div>
              <div v-if="orgLevel!=='region'" class="separate-line"></div>
              <div v-if="orgLevel!=='region'">
                <div class="base-info-num link-style"  @click="gotoSubmitPage('bu','passed',bu)">{{ bu.passedCountQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已通过</div>
              </div>
            </div>
            <div :span="8" v-else class="base-info-box">
              <div v-if="!(orgLevel==='bu'&&isBU)">
                <div class="base-info-num">{{ bu.assignQty |toThousandslsFilter()}}</div>
                <div class="base-info-text">已分配</div>
              </div>
              <div v-if="!(orgLevel==='bu'&&isBU)" class="separate-line"></div>
              <div>
                <div class="base-info-num">{{ (bu.regionAssignList&&bu.regionAssignList.length>0&&getRegionQty(bu))|toThousandslsFilter()}}</div>
                <div class="base-info-text">已下发</div>
              </div>
              <div class="separate-line"></div>
              <div>
                <div class="base-info-num link-style"  @click="gotoSubmitPage('bu','submit',bu)">{{ bu.submitCountQty |toThousandslsFilter()}}</div>
                <div class="base-info-text">已提报</div>
              </div>
              <div class="separate-line"></div>
              <div>
                <div class="base-info-num link-style"  @click="gotoSubmitPage('bu','passed',bu)">{{ bu.passedCountQty |toThousandslsFilter()}}</div>
                <div class="base-info-text">已通过</div>
              </div>
            </div>

              <div v-if="orgLevel==='hq'" class="base-info-box approva1-box">
                <div >
                  <div class="base-info-num">{{ bu.approvalCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">审核中(总)</div>
                </div>
                <div class="separate-line"></div>
                <div>
                  <div  class="base-info-num">{{ bu.approvalHQCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">HQ审核中</div>
                </div>
                <div class="separate-line"></div>
                <div>
                  <div class="base-info-num">{{ bu.approvalBuCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">BU审核中</div>
                </div>
              </div>
              <div v-else-if="orgLevel==='bu'" class="base-info-box approva1-box">
                <div>
                  <div class="base-info-num">{{ bu.approvalBuCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">BU审核中</div>
                </div>
              </div>

            <div :span="2" v-if="bu.regionAssignList&&bu.regionAssignList.length!==0"><el-button @click="showRegionInfo(bu)" class="base-info-hidden" type="text">{{bu.show?'收起':'查看更多'}}</el-button></div>
          <!-- </el-row> -->
          </div>
          <div  v-for="region of bu.regionAssignList" :key="region.regionCode">
          <div style="display:flex;width:100%" v-if="bu.show">
            <div :span="5" class="title-box">{{ getName(region.regionName)  || getName(region.orgName)}}</div>
            <div :span="8" class="base-info-box base-info-box-region">
              <div>
                <div class="base-info-num">{{ region.assignQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已分配</div>
              </div>
              <div class="separate-line"></div>
              <div>
                <div class="base-info-num link-style" @click="gotoSubmitPage('region','submit',bu,region)">{{ region.submitCountQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已提报</div>
              </div>
              <div class="separate-line"></div>
              <div>
                <div class="base-info-num link-style" @click="gotoSubmitPage('region','passed',bu,region)">{{ region.passedCountQty  |toThousandslsFilter()}}</div>
                <div class="base-info-text">已通过</div>
              </div>
            </div>
              <div v-if="orgLevel==='hq'"  class="base-info-box base-info-box-region approva1-box approva1-box-region">
                <div>
                  <div class="base-info-num">{{ region.approvalCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">审核中(总)</div>
                </div>
                <div class="separate-line"></div>
                <div>
                  <div class="base-info-num">{{ region.approvalHQCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">HQ审核中</div>
                </div>
                <div class="separate-line"></div>
                <div>
                  <div class="base-info-num">{{ region.approvalBuCountQty |toThousandslsFilter()}}</div>
                  <div class="base-info-text">BU审核中</div>
                </div>
              </div>
              <div v-else-if="orgLevel==='bu'" class="base-info-box base-info-box-region approva1-box approva1-box-region">
                <div>
                  <div class="base-info-num">{{ region.approvalBuCountQty  |toThousandslsFilter()}}</div>
                  <div class="base-info-text">BU审核中</div>
                </div>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    </div>

    <el-dialog
      :visible.sync="showConfirmDialog"  top="5vh" :before-close="handleDialogClose" width="850px" title="编辑额度分配">
      <div class="assign-region-box" v-if="inputData.length>0">
      <el-form>
        <el-form-item class="input-width-sp" label="额度分配" prop="itemQuantity" ref="itemQuantityRef">
          <el-select v-model="assignList" @change="handleChangeAssignList" multiple collapse-tags clearable placeholder="请选择">
            <div v-if="assignCodeList.length>0">
              <el-option
                v-for="item in assignCodeList"
                :key="item.orgCode"
                :label="getName(item.orgName)"
                :value="item.orgCode">
              </el-option>
            </div>
          </el-select>
          {{'总'+(!themeDetail.needTransitions?getUnits():'执行天数')}}：{{ getTotalCountQty }}&ensp;  已分配：{{getAllAssignQty}} &ensp;<span v-if="!isOwner">未分配：{{getTotalCountQty - getAllAssignQty}}</span>
          <!-- <span>总场次：{{getAllAssignQty}}场</span> -->
        </el-form-item>
        <div class="config-detail-bu">
          <div class="assign-box" >
            <el-form v-for="(item,index) of assignInfoList" :model="item" :key="item.orgName" ref="assignFormRef" :rules="editRules" hide-required-asterisk @submit.native.prevent>
              <el-form-item class="assign-item" :label="getName(item.orgName)" prop="assignQty" v-if="assignList.indexOf(item.orgCode)!==-1">
                  <el-input type="number" oninput="value=value.replace(/[^\d]/g,'')" :min="getNextAssignQty(item.regionAssignList,item.submitCountQty)" class="item" v-model="item.assignQty" placeholder="请输入分配额度"
                  @blur="(...val) => updateSubmitData(getNextAssignQty(item.regionAssignList)||item.submitCountQty,index,item.assignQty,...val)" />
                  <!-- <div> {{ getAssignQty(item.assignQty) }} </div> -->
                  <div v-if="item.saveAssignQty"> 原配额：{{ item.saveAssignQty }}</div>
                  <div v-if="isHQ&&item.regionAssignList"> 已下发：{{ getNextAssignQty(item.regionAssignList) || 0 }}</div>
                  <div v-if="isBU&&item.submitCountQty"> 已提报：{{ item.submitCountQty }}</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-form>

        <!-- <div v-if="(curAssignInfo&&curAssignInfo.length>0)">
          <div v-for="(session,index) of curAssignInfo" :key="index">
            <div class="session-info-box"></div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="subAssignList" :itemKey="index" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()"/>
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            <div class="session-info-box">
            </div>
            <div class="assign-region-item-box">
              <ConfigDetailAssignUpdate :subAssignListInfo="subAssignList" @handleSubmitAssign="handleSubmitAssign" :units="getUnits()" />
            </div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="redFont" @click="showConfirmDialog=false" >取消</el-button>
        <el-button type="danger"  @click="submit()">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import gameplanApi from "@/api/gameplan";
import { mapGetters,mapState } from 'vuex'
// import ConfigDetailAssignUpdate from './config-detail-assign-update.vue'
export default {
  components:{
    // ConfigDetailAssignUpdate
  },
  props: {
    configInfo:{ type: Object, default: () => { } },
    itemKey:{ type: String, default: '' },
    themeChannelCode:{ type: String, default: '' },
    submitInfo:{ type: Object, default: () => { } },
    isOwner:{ type: Boolean, default: false },
    isSubmited:{ type: Boolean, default: false },
    themeId:{ type: String, default: '' },
    orgLevel:{ type: String, default: '' },
  },
  data() {
    var validatePocCountMin = (rule, value, callback) => {
      if(Number(value)<1){
        return callback(new Error('最小售点数需大于等于1'));
      }else {
        callback()
      }
    };
    return {
      assignList:[],
      curAssignInfo:[],
      assignCodeList:[],
      assignInfoList:[],
      themeConfig:{},
      themeDecorates:[],
      saveInfo:{},
      params: {
        needVerify: 1,
        needConstruct: 1,
        needSpr: 1,
        needSupervisor: 1,
        needPerformance:1,
        themeDecorateCodes: [],
        pocCountMin: '',
        pocRelateType:2,
        pgQtyLimit:'',
        investUnit:'',
        needTransitions:1,
        itemQuantity:'',
        perExecDays:'',
      },
      themeDetail:{},
      editRules: {
        needVerify: [{ required: true, message: '请选择是否需要场勘', trigger: 'change' }],
        needConstruct: [{ required: true, message: '请选择是否需要搭建', trigger: 'change' }],
        needSpr: [{ required: true, message: '请选择是否需要Spr', trigger: 'change' }],
        needPerformance: [{ required: true, message: '打卡/执行信息上传方式', trigger: 'change' }],
        themeDecorateCodes: [{ required: true, message: "请选择装饰点位", trigger: "blur" }],
        pocCountMin: [{ validator:validatePocCountMin, trigger: "blur" },
                        { required: true, message: "请输入售点数量"}],
        region: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
        isAssign:[{required: true, message: '请选择分配额度', trigger: 'change' }],
        itemQuantity: [{ required: true, message: '请设置道具数量', trigger: 'blur' }],
        perExecDays:[{required: true, message: '请输入活动天数', trigger: 'blur' }],
        pgQtyLimit: [{ required: true, message: '请输入临促人员人数限制', trigger: 'blur' }],
        investUnit:[{required: true, message: '请输入单场投入预算', trigger: 'blur' }],
        assignQty:[{required: true, message: '请输入额度配置', trigger: 'blur' }],
      },
      radioList: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      mandatoryDecorates: [],
      themeLevelsInfo: {},
      subAssignItem:{},
      subAssignList:[],
      assignBu:[],
      showDecorates:[],
      isSave:false,
      saveConfig:{},
      themeStyles:{},
      saveSubAssignList:[],
      employeeLevel:'',
      btnType:'',
      //cityPoolList:[],
      showSaveAssignList:false,
      showConfirmDialog:false,
      inputData:[],
      submitAssignList:[],
      assignDetailList:[],
      executorList:[]
    }
  },
  computed:{
     ...mapGetters(['userInfo']),
     ...mapState({
      buList: state => state.gameplan.buList,
      regionList: state => state.gameplan.regionList,
      areaList: state => state.gameplan.areaList
    }),
     pocRelateTypeDesc () {
      if (this.themeConfig.pocRelateType === 0) {
        return '当前活动形式无需执行售点'
      } else if (this.themeConfig.pocRelateType === 1) {
        return '当前活动形式需要单售点执行'
      } else if (this.themeConfig.pocRelateType === 2) {
        return '当前活动形式需要多售点执行'
      } else {
        return ''
      }
    },
    isHQ(){
      return this.employeeLevel>=90
    },
    isBU(){
      return this.employeeLevel>=60&&this.employeeLevel<90
    },
    isRegion(){
      return this.employeeLevel>=45&&this.employeeLevel<60
    },
    getAssignName(){
      if(this.isHQ) return 'BU额度配置'
      else if(this.isBU) return '销售大区额度配置'
      else return '销售大区额度配置'
    },
    getAssignList(){
      if(this.isHQ) return this.buList
      else if(this.isBU) return this.regionList
      else return this.areaList
    },
    getTotalCountQty(){
      let assignQty
      if(this.curAssignInfo&&this.curAssignInfo.length>0){
        assignQty = this.curAssignInfo[0].assignQty
      }else {
        assignQty = this.subAssignList.reduce((pre,item)=>{
          return pre + Number(item.assignQty)
        },0)
      }
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty
    },
    getAllAssignQty(){
       let assignQty = this.assignInfoList.reduce((pre,item)=>{
        return pre + Number(item.assignQty)
      },0)
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return assignQty || 0
    }
  },
  watch:{
    isSubmited(val){
      if(val){
        this.subAssignList = this.submitInfo.subAssignList
      }
    },
    configInfo:{
      handler:function(){
        this.init()
      },
      immediate:true,
      deep:true
    }
  },
  created() {
    this.init()
  },
  mounted(){
  },
  methods: {
    init(){
      this.employeeLevel = this.userInfo.employeeLevel
      if(!this.isSubmited) this.saveInfo = this.configInfo.saveInfo || {}
      else this.saveInfo = this.submitInfo || {}
      this.themeDetail = this.saveInfo.themeDetail || {}
      this.executorList = this.saveInfo.executorList || []
      this.themeConfig =  this.configInfo.themeConfig || {pocRelateType:this.saveInfo.themeDetail.pocRelateType,themeDecorates:this.saveInfo.themeDetail.themeDecorates}
      this.subAssignList = this.saveInfo.subAssignList || (this.submitInfo&&this.submitInfo.subAssignList) || []
      if(this.isHQ) {
        this.assignDetailList = this.subAssignList
        this.assignCodeList = this.buList || []
      }
      else if(this.isBU) {
        //this.$nextTick(()=>{
          if(!this.isSubmited){
            this.assignDetailList = this.saveInfo.curAssignList
            this.assignDetailList[0].regionAssignList = this.saveInfo.subAssignList
          }else {
            if(this.isOwner){
              const data = {
                buCode: this.userInfo.buCode,
                buName: this.userInfo.buName,
                regionAssignList: this.submitInfo&&this.submitInfo.subAssignList
              }
              this.assignDetailList = [data]
            }else {
              this.assignDetailList = this.configInfo.saveInfo.curAssignList
              this.assignDetailList[0].regionAssignList = this.submitInfo&&this.submitInfo.subAssignList
            }
          }
          this.assignCodeList = this.regionList || []
        //});
      }
      else if(this.isRegion) {
        if(!this.isSubmited) this.assignDetailList = this.saveInfo.curAssignList
        else this.assignDetailList = this.submitInfo&&this.submitInfo.subAssignList
        //this.assignDetailList[0].regionAssignList = this.saveInfo.subAssignList
        this.assignCodeList = this.areaList || []
      }
      if(!this.isSubmited){
        this.assignInfoList =  this.assignCodeList.map(assignItem=>{
          let data = {
            orgName:assignItem.orgName,
            orgCode:assignItem.orgCode,
            assignQty:'',
            regionAssignList:[],
            assignId:(this.subAssignList[0]&&this.subAssignList[0].assignId) || ''
          }
          return data
        })
      }
      //console.log(this.configInfo);
      if(this.themeConfig)
      this.showDecorates = (this.themeConfig&&this.themeConfig.showDecorates) ||[]
      if(Object.keys(this.saveInfo).length>0){
        this.curAssignInfo = this.saveInfo.curAssignList
        if(Object.keys(this.saveInfo.themeDetail).length!==0){
          for(let key in this.params){
            this.params[key] = this.saveInfo.themeDetail[key]
          }
        }
        if(this.saveInfo.subAssignList){
          let key
          if(this.isHQ) key ='buCode'
          else if(this.isBU) key='regionCode'
          else if(this.isRegion) key='regionCode'
          this.assignList = this.saveInfo.subAssignList.map(item=>{
            return item[key]
          })
          this.saveInfo.subAssignList.forEach(savedItem=>{
            this.assignInfoList.forEach(assignItem=>{
              if(savedItem[key]===assignItem.orgCode){
                //console.log(savedItem.submitCountQty);
                assignItem.assignQty = savedItem.assignQty
                assignItem.saveAssignQty = savedItem.assignQty
                assignItem.regionAssignList = savedItem.regionAssignList
                assignItem.submitCountQty = savedItem.submitCountQty
                //assignItem.assignId = savedItem.assignId
              }
            })
          })
        }
      }
      if(this.isHQ) {
        this.assignDetailList.forEach(bu=>{
          bu.ececutorNameList = []
          this.executorList.forEach(executor=>{
            if(executor.buCode===bu.buCode){
              bu.ececutorNameList.push(executor.executorName)
            }
          })
        })
      }
    },
    getUnits(){
      let key = this.themeConfig.pocRelateType+''
      let units = '街区'
      switch (key) {
        case '0':
          units = '活动地点'
          break;
          case '1':
          units = '售点'
          break;
        default:
        units = '街区'
          break;
      }
      return units
    },
    getNextAssignQty(list,submitCountQty){
      if(this.isBU){
        return submitCountQty || 0
      }else if(this.isHQ){
        let assignQty = list.reduce((pre,item)=>{
          return pre + Number(item.assignQty)
        },0)
        return assignQty || 0
      }
      // return this.params.needTransitions?assignQty:assignQty*this.params.perExecDays
      return 0
    },
    handleChangeAssignList(){
      this.assignInfoList.forEach(assignItem=>{
        const isSelected = this.assignList.indexOf(assignItem.orgCode)!==-1
        if(!isSelected){
          assignItem.assignQty=''
        }
      })
    },
    updateSubmitData(min,index,assignQty){
      if(Number(min)>Number(assignQty)&&assignQty!==''){
        this.assignInfoList[index].assignQty=''
        this.$message.error(`额度分配不可小于${this.isHQ?'已下发':'已提报'}`)
      }
    },
    submit(type){
      let subAssignList = this.assignInfoList.filter(assignItem=>{
          //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
        return this.assignList.indexOf(assignItem.orgCode)!==-1
      })
      let valid = true
      subAssignList.forEach(item=>{
        item.assignQty===''?valid = false:''
      })
      if(!valid) return this.$message.error('请输入额度分配')
      if((this.getTotalCountQty - this.getAllAssignQty)<0&&!this.isOwner) return this.$message.error('额度超出可分配数量！')
      this.$confirm('是否确认修改配额?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'btn-red',
        type: 'warning'
      }).then(() => {
        this.handleThemeRelocation()
      }).catch(() => {
      });
    },
    async handleThemeRelocation(){
      let themeDetail = {
        themeDetailId:this.themeDetail.themeDetailId,
        themeId:this.themeDetail.themeId
      }
      let subAssignList = this.assignInfoList.filter(assignItem=>{
          //console.log(this.assignList.indexOf(assignItem.orgCode)!==-1);
        return this.assignList.indexOf(assignItem.orgCode)!==-1
      })
      subAssignList = subAssignList.map(assignItem=>{
        let key
        if(this.isHQ) key ='buCode'
        else if(this.isBU) key='regionCode'
        else if(this.isRegion) key='regionCode'
        key?assignItem[key] = assignItem.orgCode:''
        return assignItem
      })
      let params = {
        subAssignList,
        themeDetail,
        curAssignList:this.curAssignInfo
      }
      //console.log(params);
      const { data } = await gameplanApi.getGameplanThemeRelocation(params);
      if (data.resultCode === "0") {
        this.$message.success("修改成功！")
        window.location.reload()
      }
    },
    handleSubmitAssign(subAssignList){
      this.submitAssignList = subAssignList
    },
    getTotal(list,index){
      let total = 0
      // total = list[index].reduce((pre,cur)=>{
      //   if(cur.assignStatus==100){
      //     return pre+Number(cur.assignQty)
      //   }else {
      //     return pre
      //   }
      // },0)
      return total
    },
    getResult(){
      let itemKey = 0
      let assignQty = 0
      if(this.curAssignInfo&&this.curAssignInfo.length>0){
        assignQty = this.curAssignInfo[itemKey].assignQty
      }else{
        assignQty = this.getTotal(this.subAssignList,itemKey)
      }
      //console.log(assignQty);
      //let assignQty = this.curAssignInfo[assignItemKey].assignQty
      let result = 0
      if(this.submitAssignList[itemKey]){
        // result = this.getTotal(this.submitAssignList,itemKey)
        result = 0
      }
      if(this.isBU){
        if((assignQty-result)<0){
        }
      }else if(this.isHQ){
        if((assignQty-result)!=0){
        }
      }
      //console.log(this.submitAssignList);
      //console.log(result);
      return (assignQty - result)
    },
    showEditDialog(){
      this.inputData = []
      let count = 0
      if(this.isHQ) this.assignCodeList = this.buList || []
      else if(this.isBU) this.assignCodeList = this.regionList || []
      else if(this.isRegion) this.assignCodeList = this.areaList || []
      if(this.isSubmited){
        this.assignInfoList =  this.assignCodeList.map(assignItem=>{
          let data = {
            orgName:assignItem.orgName,
            orgCode:assignItem.orgCode,
            assignQty:'',
            regionAssignList:[],
            assignId:(this.subAssignList[0]&&this.subAssignList[0].assignId) || ''
          }
          this.subAssignList.map(item=>{
            if(item.orgCode === assignItem.orgCode) data.assignQty = item.assignQty
            // let data = {
            //   assignQty:item.assignQty,
            //   regionCode:item.regionCode
            // }
            // count+=item.assignQty
            // this.inputData.push(data)
          })
          return data
        })
      }
      if(this.isBU){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            regionCode:item.regionCode
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }else if(this.isHQ){
        this.subAssignList.map(item=>{
          let data = {
            assignQty:item.assignQty,
            buCode:item.buCode,
            assignStatus:item.assignStatus,
          }
          count+=item.assignQty
          this.inputData.push(data)
        })
      }
      this.total = this.subAssignList.assignQty || count
      this.count = count
      this.remain = this.subAssignList.assignQty - count || 0
      this.showConfirmDialog = true
    },
    handleInputAssign(index){
      this.inputData[index].assignQty=this.inputData[index].assignQty||0
      let sum = this.inputData.reduce((pre,cur)=>{
        return pre+=Number(cur.assignQty)
      },0)
      this.remain = this.total - sum
      for(let i=0;i<this.inputData.length;i++){
        if(this.inputData[i].assignQty<this.getRegionQty(this.subAssignList[i])||this.inputData[i].assignQty<this.subAssignList[i].submitCountQty){
          return
        }
      }
      if(this.isHQ){
        //console.log(this.inputData[index].assignQty);
        //console.log(this.getRegionQty(this.subAssignList[index]));
        if(this.inputData[index].assignQty<this.getRegionQty(this.subAssignList[index])||this.remain<0){
          return
        }
      }else {
        if(this.inputData[index].assignQty<this.subAssignList[index].submitCountQty||this.remain<0){
          return
        }
        if(this.remain < 0){
          return
        }
      }
    },
    handleDialogClose(){
      this.inputData = []
      this.showConfirmDialog=false
    },
    getRegionQty(assignItem){
      let result = 0
      if(assignItem.regionAssignList){
        for(let item of assignItem.regionAssignList){
          result+=Number(item.assignQty)
        }
      }
      return result
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex },session) {
      if(this.isHQ){
        if (columnIndex === 0 ) {
          if(rowIndex===0){
            return {
              rowspan: session.regionAssignList&&session.regionAssignList.length || 1,
              colspan: 1
            }
          }else if(rowIndex!=0){
            return {
              rowspan:0,
              colspan:0
            }
          }
        }
      }else if(this.isBU){
        if (columnIndex === 0) {
          if (rowIndex % this.subAssignList.length === 0) {
            return {
              rowspan: this.subAssignList.length,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    getCount(type){
      let result = 0
      for(let item of this.subAssignList){
        result += Number(item[type])
      }
      return result
    },
    getAssignQty(assignQty){
      if(assignQty){
        return `活动场次：${this.params.needTransitions?assignQty:assignQty*this.params.perExecDays}场`
      }
    },
    getName(str){
      if(str){
          return str.split('|')[0] || str
      }else return ''
    },
    getThemeDecorates(themeDecoratesList){
      if(themeDecoratesList&&themeDecoratesList.length>0){
        let res = []
        for(let item of themeDecoratesList){
          res.push(item.decorateName)
        }
        return res.join('、')
      }else return ''
    },
    gotoSubmitPage(type,btn,bu,region){
      let isPassed = btn==='passed'
      if(bu.submitCountQty&&bu.submitCountQty!==0){
        let buCode= ''
        let buName= ''
        let regionCode =''
        let regionName =''
        if(this.isHQ){
          buCode= bu.buCode
          buName= bu.buName||bu.orgName
          if(type==='region'){
            regionCode = region.regionCode
            regionName = region.regionName
          }
        }else if(this.isBU){
          buCode= this.userInfo.buCode
          buName= this.userInfo.buName
          if(type==='region'){
            regionCode = region.regionCode
            regionName = region.regionName
          }
        }else if(this.isRegion){
          buCode = bu.buCode
          buName = bu.buName
          regionCode = this.userInfo.regionCode
          regionName = this.userInfo.regionName
        }
        this.$router.push({path:'/gameplan/activity-report/waitReport',query:{
          routerType:'skip',
          themeChannelCode:this.saveInfo.themeDetail.themeChannelCode,
          themeStyleCode:this.saveInfo.themeDetail.themeStyleCode,
          themeLevelCode:this.saveInfo.themeDetail.themeLevelCode,
          themeId:this.themeId,
          isPassed,
          buCode:buCode,
          buName:buName,
          regionCode:regionCode,
          regionName:regionName}
        })
      }
    },
    showRegionInfo(bu){
      if(!bu.show) this.$set(bu,'show',true)
      else bu.show=!bu.show
    },
    getExecutorName(bu){
      if(this.isBU) return this.userInfo.clientName
      return bu.ececutorNameList.join('、')
    }
  }
}
</script>

<style lang="scss" scoped>
.assign-item{
  margin-right: 15px;
}
::v-deep .el-dialog{
  margin: 0 auto 15px;
}
::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 60vh;
}
::v-deep .el-table{
  width: 700px;
}
.table-box{
  margin: -1px 0 0px 200px;
  border-radius:5px;
  border:solid 1px rgb(228, 228, 228);
}
::v-deep .el-form-item__label{
  text-align: left;
}
.submit_item_btn {
  width: 100px;
  cursor: pointer;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  //width: 100px;
  border-radius: 5px;
  text-align: center;
  vertical-align: middle;
  color: white;
  background-color: rgb(204, 0, 0);
}
.submit_item_btn_disabled{
  background-color: $base-grey !important;
  cursor: no-drop;
}
.margin-left--100{
  margin-left: -70px;
}
.assign-all{
  display: flex;
  flex-direction: column;
  line-height: 25px;
}
.item_assign_region{
  margin: 0px 0 0  200px;
}
.item_assign_first_box{
  display: flex;
  flex-wrap: wrap;
}
.item_assign_second{
  display: flex;
  flex-wrap: wrap;
}
.item_assign{
  //display: flex;
  margin:0 40px 0px 0;
  // border: 1px solid grey;
}
.item_assign_first{
  margin:0 30px 30px 0;
}

  .item_detail{
    //width: 900px;
    font-size: 15px;
    margin: 0px 15px 30px 15px;
    display: flex;
    .edit-btn{
      cursor: pointer;
      margin: 0px 0 20px 0px;
      font-size: 12px;
      width: 50px;
      text-align: center;
      padding: 8px 7px;
      color: rgb(197, 11, 8);
      border: 1px solid rgb(197, 11, 8);
      border-radius: 4px;
      line-height: 12px;
    }
  }
  .item_title{
    display: inline-block;
    min-width: 165px !important;
    font-weight: 700;
    color: black;
    text-align: right;
    margin-right: 20px;
  }
  .infoBox_cross_line_box {
  margin: -10px 0px 30px 15px;
  font-weight: 600;
  color: rgb(182, 182, 182);
  .infoBox_cross_line{
    width:1000px;
    height: 1px;
    background-color: rgb(238, 238, 238);
    margin: -9px 0 0 0px;
  }
}
.select-item-box{
  margin-left: 100px;
  width: 400px;
  display: flex;
  justify-content: space-evenly;
}
.color-green{
  color: rgb(42, 219, 33);
}
.color-red{
  color: rgb(219, 93, 33)
}
.font-red{
  color: rgb(226, 0, 0);
}
.item_assign{
  //display: flex;
  margin:0 40px 0px 0;
  // border: 1px solid grey;
}
.item_assign_first{
  margin:0 30px 30px 0;
}
.normal_box{
  padding-left: 30px;
}
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}
::v-deep .el-form-item {
  margin-bottom:8px;

  .el-form-item__label {
    color: black;
    font-weight: 600;
    margin-left:3px;
  }

  .el-form-item__content {
    line-height: 35px !important;
  }
}
::v-deep .el-input__inner {
  width: 200px !important;
}
::v-deep .input-width-sp .el-input__inner {
  width: 155px;
}
::v-deep .el-select {
  margin: 0 20px 20px 0;
}
.el-form-item{
  width: 100%;
}
.sp-el-form{
  width: 75%;
  position: relative;
  left: 180px;
  margin-top: -65px;
  display: flex;
  flex-wrap: wrap;
}
::v-deep .el-form-item__error{
  width: 150px;
}


::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    margin-left: -10px;
}

// ::v-deep .el-select__tags {
//   display: flex;
//   flex-wrap: nowrap !important;
//   height: 35px;
//   overflow: hidden;
// }

// 额度分配
::v-deep .assign-box .el-input__inner {
  width: 155px !important;
  padding-right: 25px;
}
::v-deep .assign-box .el-form-item {
  display: flex;
  flex-direction: column;
}
.assign-box{
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
// 装饰点位 默认选中 灰色样式
::v-deep .sp .el-checkbox__input.is-checked .el-checkbox__inner,.sp .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #b5b5b5 !important;
    border-color: #b5b5b5 !important;
}
::v-deep .sp .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #ffffff !important;
    color: #606266 !important;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266 !important;
}
.el-checkbox{
  margin-right: 20px;
}
.decorate-style{
  width: 750px;
  display:flex;
  flex-wrap: wrap;
}
.link-style{
  color: rgb(0, 149, 236);
  cursor: pointer;
}
.title-box{
  text-align:center;
  width:16%;
  margin:0px 5px 0 5px;
  font-size:14px;
  align-self: center;
}
.base-info-box{
  border:solid 1.5px rgb(152, 208, 240);
  display:flex;
  width:32%;
  height:65px;
  border-radius:5px;
  padding:10px auto;
  text-align:center;
  align-items:center;
  justify-content:space-evenly;
  margin:10px 2%;
  background-color:rgb(244, 250, 255);
}
.approva1-box{
  border:solid 1px rgb(253, 158, 151) !important;
  background-color:rgb(255, 244, 244);
}
.base-info-num{
  font-size:18px;
  line-height:27px;
}
.base-info-text{
  font-size:12px;
  margin-top:5px;
  color:rgb(156, 156, 156);
}
.base-info-box-region{
  width:27%;
  margin:10px 4.3%;
  background-color:white ;
}
.approva1-box-region{
  margin-left:40px !important;
}
.base-info-hidden{
  margin-top:24px;
}
.separate-line{
  width:1px;
  height:30px;
  background-color:rgb(224, 224, 224);
}
</style>
